import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el ebook?',
  a: 'Una vez realizada la compra, recibirás inmediatamente un email con el enlace de descarga del ebook en formato PDF. Podrás acceder a él de por vida.'
}, {
  q: '¿Para qué edades sirve?',
  a: 'Los cuentos están pensados para niños de 3 a 10 años, aunque cada relato puede adaptarse a la sensibilidad y edad de cada niño. Muchos padres también disfrutan leyéndolos.'
}, {
  q: '¿Y si no me funciona?',
  a: 'Contás con una garantía de 7 días. Si dentro de ese plazo sentís que no es para vos, te devolvemos el 100% de tu dinero sin hacer preguntas.'
}, {
  q: '¿Necesito imprimirlo?',
  a: 'No es necesario. Podés leerlo cómodamente desde tu celular, tablet o computadora. Si querés, también podés imprimirlo en casa.'
}, {
  q: '¿Es un pago único?',
  a: 'Sí. Es un único pago, sin suscripciones ni cobros recurrentes. Una vez que lo compres, es tuyo para siempre.'
}, {
  q: '¿Qué medios de pago aceptan?',
  a: 'Aceptamos tarjeta de crédito y débito, Mercado Pago y transferencia bancaria. Todos los pagos son 100% seguros.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-6 lg:px-8 bg-cream" data-id="element-50">
      <div className="max-w-3xl mx-auto" data-id="element-51">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-52">
          <h2 className="text-4xl md:text-5xl font-serif font-medium text-indigo" data-id="element-53">
            Preguntas frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-54">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.05
          }} className="bg-white rounded-2xl border border-blush/30 overflow-hidden" data-id="element-55">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left hover:bg-cream/50 transition-colors" data-id="element-56">
                  <span className="font-serif text-lg text-indigo" data-id="element-57">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 text-gold flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-58" />
                </button>
                <AnimatePresence initial={false} data-id="element-59">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-60">
                      <p className="px-6 pb-5 text-indigo/70 leading-relaxed" data-id="element-61">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}